import React, { FC, useMemo, useRef, useState } from 'react';

import { Column, FilterRow, HeaderFilter, Pager, Paging } from 'devextreme-react/data-grid';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import { useAuth } from 'context/auth';
import { Button, DataGrid } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';

import { DriverMixerSalaryModalCreate, DriverMixerSalaryModalDelete } from './components';

type Props = {
  selectId: number;
};

const DriverMixerSalary: FC<Props> = ({ selectId }) => {
  const refGrid = useRef<DataGrid | null>(null);
  const { getClaims }: any = useAuth();

  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [modalIsVisibleDelete, setModalIsVisibleDelete] = useState(false);
  const [detailId, setDetailId] = useState<number | null>(null);

  const dataStore: any = useMemo(() => {
    const defaultFilter = ['objectId', '=', selectId];
    return $createStore('/v1/DriverMixerSalary/configuration', 'id', { defaultFilter });
  }, [selectId]);

  const refresh = () => refGrid.current?.instance.refresh();

  const isCanEditDriverMixerSalaryConfiguration = getClaims(['CanEditDriverMixerSalaryConfiguration']);

  return (
    <div>
      {modalIsVisible && (
        <DriverMixerSalaryModalCreate
          changeVisible={setModalIsVisible}
          id={detailId}
          refresh={refresh}
          objectId={selectId}
          visible={modalIsVisible}
        />
      )}
      {modalIsVisibleDelete && (
        <DriverMixerSalaryModalDelete
          changeVisible={setModalIsVisibleDelete}
          visible={modalIsVisibleDelete}
          refresh={refresh}
          id={detailId}
        />
      )}

      <div className="pt-1">
        <AppLayoutTop title="">
          <Button
            width={120}
            text="Добавить"
            type="default"
            onClick={() => {
              setDetailId(null);
              setModalIsVisible(true);
            }}
            visible={isCanEditDriverMixerSalaryConfiguration}
          />
        </AppLayoutTop>
      </div>
      <AppCard>
        <DataGrid
          dataSource={dataStore}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          key="id"
          ref={refGrid}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
        >
          <FilterRow visible={true} />
          <HeaderFilter visible />

          <Column dataField="factoryName" caption="Площадка" />
          <Column dataField="quantity" caption="Объем" />
          <Column dataField="residentSalary" caption="ЗП резидента" />
          <Column dataField="nonResidentSalary" caption="ЗП нерезидента" />
          <Column dataField="dateBegin" caption="Дата начала" dataType="date" width={120} />
          <Column dataField="dateEnd" caption="Дата окончания" dataType="date" width={120} />
          <Column
            dataField="actions"
            caption=""
            width={120}
            allowFiltering={false}
            visible={isCanEditDriverMixerSalaryConfiguration}
            allowSorting={false}
            cellRender={(data) => (
              <>
                <Button
                  icon="edit"
                  type="default"
                  stylingMode="text"
                  onClick={() => {
                    setDetailId(data.data.id);
                    setModalIsVisible(true);
                  }}
                />
                <Button
                  icon="trash"
                  type="default"
                  stylingMode="text"
                  onClick={() => {
                    setDetailId(data.data.id);
                    setModalIsVisibleDelete(true);
                  }}
                />
              </>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default DriverMixerSalary;
